import APIDOC from '@/common/serverApi';
import { get, post, postJSON, postParams,postFormData } from '@/common/request';
export default {
    namespaced: true, state: {}, mutations: {}, actions: {
        getThesisRequestListByStudent({ commit }, payload) {  //论文要求获取列吧
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.THESIS.getThesisRequestListByStudent, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        getMyApplyList({ commit }, payload) {  //论文报名列表
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.THESIS.getMyApplyList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        getThesisCheckDetailByParam({ commit }, payload) {  //根据登录学生的信息查询学生论文所有信息（包括提交记录，审核记录）
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.THESIS.getThesisCheckDetailByParam, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        getEfficientThesisBatch({ commit }, payload) {  //获取生效的批次信息
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.THESIS.getEfficientThesisBatch, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        commitChoice({commit}, payload) { //学生提交选题信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.commitChoice, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        editChoice({commit}, payload) { //学生修改选题信息
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.editChoice, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        commitProposal({commit}, payload) { //学生提交开题报告
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.commitProposal, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        editProposal({commit}, payload) { //修改开题报告
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.editProposal, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        commitDraft({commit}, payload) { //提交初稿
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.commitDraft, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        editDraft({commit}, payload) { //修改初稿
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.editDraft, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        commitFinal({commit}, payload) { //提交终稿
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.commitFinal, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        editFinal({commit}, payload) { //修改终稿
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.editFinal, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        queryStudentIsCommitThesis({ commit }, payload) {  //查询是否有提交论文资格
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.THESIS.queryStudentIsCommitThesis, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },

        commitWanXinPlagiarismCheck({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postFormData(APIDOC.THESIS.commitWanXinPlagiarismCheck, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        thesisPlagiarismCheckList({commit}, payload) {
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postFormData(APIDOC.THESIS.thesisPlagiarismCheckList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        thesisBindingMaterialList({ commit }, payload) {  //胶装材料列表
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.THESIS.thesisBindingMaterialList, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },
        commitBindingMaterial({commit}, payload) { //提交胶装材料
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.commitBindingMaterial, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        editBindingMaterial({commit}, payload) { //修改胶装材料
            commit('STARTREQUEST', null, {root: true});
            return new Promise((resolve, reject) => {
                postJSON(APIDOC.THESIS.editBindingMaterial, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, {root: true});
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, {root: true});
                        reject(err);
                    });
            });
        },
        getDeadline({ commit }, payload) {  //查询学生论文提交的截止日期
            commit('STARTREQUEST', null, { root: true });
            return new Promise((resolve, reject) => {
                get(APIDOC.THESIS.getDeadline, payload)
                    .then((result) => {
                        commit('ENDREQUEST', null, { root: true });
                        resolve(result);
                    })
                    .catch((err) => {
                        commit('ENDREQUEST', null, { root: true });
                        reject(err);
                    });
            });
        },

        
    }
}


// WEBPACK FOOTER //
// ./src/store/thesis.js